import React, { useEffect, useState } from 'react';
import { Container, Row, Col, ListGroup, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getSlackChannels, setSlackChannel } from '../../services';
import Loading from '../DocList/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { setIntegrationAvailable, setIntegrationData } from '../../redux/slices/integrationsSlice';
import { selectAuthToken } from '../../redux/selectors/authSelectors';

const SlackChannel = () => {
  const token = useSelector(selectAuthToken);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [channels, setChannels] = useState([]);

  const [checkedItems, setCheckedItems] = useState([]); //plain object as state

  const handleChange = (event) => {
    // updating an object instead of a Map
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  // useEffect(() => {
  // }, [checkedItems]);

  useEffect(() => {
    /* need profile id */
    setIsLoading(true);
    getSlackChannels(token).then((res) => {
      if (res && res.channels) {
        let default_channel = {};

        res.channels.map(({ channelId, applicationChannel }) => {
          if (applicationChannel === true) {
            default_channel = { ...default_channel, [channelId]: true };
          }
        });

        setCheckedItems(default_channel);
        setChannels(res.channels);
        //setIsSlackConfigured(true);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);

  const handleJoinClick = () => {
    /* you could rewrite this */
    /*
    const keys = Object.keys(checkedItems);
    let selChannels = [];
    keys.forEach((key, index) => {
      if (checkedItems[key] === true) {
        selChannels.push(key);
      }
    });
    */

    const selChannels = Object.keys(checkedItems).filter(
      (key) => checkedItems[key] === true
    );

    setSlackChannel(selChannels).then((status) => {
      if (status === true) {
        toast.success('Success: Set channel(s) as indicated', {
          position: 'top-right',
          autoClose: 4000,
        });
        dispatch(setIntegrationAvailable({ id: 'slack', available: true }));
        const selChannelsFull = channels.filter(
          (channel) => selChannels.indexOf(channel.channelId) > -1
        );
        dispatch(
          setIntegrationData({
            id: 'slack',
            data: { channels: selChannelsFull },
          })
        );
      } else {
        toast.error('An error occurred saving your channel selection.', {
          position: 'top-right',
          autoClose: 4000,
        });
      }
    });
  };

  return (
    <Container>
      <Row>
        <Col lg={12} className='mt-4 slack_channel_wrap'>
          <div className='channellist-wrap'>
            {channels && channels.length ? <>
              <h3 className='slack_channellist_heading'>Choose Slack Channels</h3>
              <p style={{ textAlign: 'center' }}>
                This is where your team will see shared documents and other
                messages.
              </p>
              <ListGroup as='ol' numbered>
                <Form>
                  {channels.map(
                    ({
                      channelId,
                      name,
                      topic,
                      purpose,
                      applicationChannel,
                    }) => (
                      <ListGroup.Item
                        as='li'
                        className='d-flex justify-content-between align-items-start'
                        key={channelId}
                      >
                        <Form.Check type='checkbox' id={channelId}>
                          <Form.Check.Input
                            type='checkbox'
                            name={channelId}
                            checked={checkedItems[channelId]}
                            onChange={handleChange}
                          // checked={applicationChannel == true ? 'checked' : ''}
                          />
                          <Form.Check.Label>
                            <div className='ms-2 me-auto'>
                              <div
                                className='fw-bold'
                                style={{ fontSize: '1.2em' }}
                              >
                                {name}
                              </div>
                              {topic}
                              {purpose && purpose !== '' ? (
                                <div>({purpose})</div>
                              ) : null}
                            </div>
                          </Form.Check.Label>
                        </Form.Check>

                        {/* <a
                    style={{ cursor: 'pointer' }}
                    className='join_slack_channel'
                    onClick={(e) => handleJoinClick(e, channelId)}
                  >
                    Join Now
                  </a> */}
                      </ListGroup.Item>
                    )
                  )}
                </Form>
                <button
                  className='slack-join-channel-btn'
                  onClick={handleJoinClick}
                >
                  {' '}
                  Join Now
                </button>
              </ListGroup>
            </> :
              (isLoading ?
                <Container>
                <Row>
                  <Col className='d-flex justify-content-center'>
                    <Loading />
                  </Col>
                </Row>
              </Container>
        
                :
                <div style={{ textAlign: "center", marginTop: "20px", opacity: 0.8 }}>
                  <h5>No Slack channels found</h5>
                  <p style={{ maxWidth: "700px", margin: "0 auto" }}>
                    It looks like Slack isn’t connected or there are no channels available.
                    <br /> Please check your Slack connection under{" "}
                    <strong>Integrations → Configuration</strong> and reconnect your workspace.
                  </p>
                </div>)}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SlackChannel;
